import { render, staticRenderFns } from "./memberTag.vue?vue&type=template&id=7e8bfd4e&scoped=true"
import script from "./memberTag.vue?vue&type=script&lang=js"
export * from "./memberTag.vue?vue&type=script&lang=js"
import style0 from "./memberTag.vue?vue&type=style&index=0&id=7e8bfd4e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e8bfd4e",
  null
  
)

export default component.exports